module.exports = __webpack_public_path__ + "static/media/add-product-2.6f7696eb.jpg";